import axios from './axios'
import generateService from './generator'

const endpoint = 'patient/me/tasks';

const base = generateService(endpoint);

function fetchToday() {
    return axios.get(`${endpoint}/today`).then(response => {
        return response.data;
    }).catch(e => {
        throw e
    });
}

function complete(id, data) {
    return axios.post(`${endpoint}/${id}/complete`, data).then(response => {
        return response.data;
    }).catch(e => {
        throw e
    });
}

function skip(id) {
    return axios.post(`${endpoint}/${id}/skip`).then(response => {
        return response.data;
    }).catch(e => {
        throw e
    });
}

function revert(id) {
    return axios.post(`${endpoint}/${id}/revert`).then(response => {
        return response.data;
    }).catch(e => {
        throw e
    });
}

export default {
    fetchList: base.fetchList,
    fetchAll: base.fetchAll,
    fetchItem: base.fetchItem,
    fetchToday,
    complete,
    skip,
    revert
}
